"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const request_1 = __importDefault(require("@hotmart/request"));
request_1.default.register(`${Settings_1.default.api.backofficePlayer}/`, {
    get: {
        'hotmartPlayerBackoffice.defaultFolderMediaItems': 'v1/player/library?category=media&page=:page&elementPerPage=:elementPerPage',
        'hotmartPlayerBackoffice.defaultFolderItems': 'v1/player/library?category=folder&page=:page&elementPerPage=:elementPerPage',
        'hotmartPlayerBackoffice.itemsFromfolderCode': 'v1/player/library/folder/:folderCode?page=:page&elementPerPage=:elementPerPage&key=create_date&direction=dsc'
    },
    post: {
        'hotmartPlayerBackoffice.search': 'v1/player/library/search?page=:page&elementPerPage=:elementPerPage'
    }
});
